import React            from 'react';

class Option extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div className={ `simprakit-dropdown-list-option${ p.isFocused ? ' focused ' : ' ' }` }>
                { p.children }
            </div>
        )
    }
}

export default Option;